module.exports = __webpack_public_path__ + "img/q9.83ce70a1.png";